import React from 'react';
import { ClientEngagementNoMatchMessage } from '@axiom/const';

import { EmptyLayout } from '../../layout/EmptyLayout/EmptyLayout';
import { Visible } from '../../layout/Visible/Visible';
import NoResults from '../../../public/static/svg/man-walking.svg';
import { Gutter } from '../../layout/Gutter/Gutter';
import { Card } from '../../layout/Card/Card';
import { CardSection } from '../../layout/Card/CardSection';
import { SmallHeader } from '../../content/SmallHeader/SmallHeader';
import { Paragraph } from '../../content/Paragraph/Paragraph';

export const ClientEngagementSelfServiceNoTalentForPdf = () => (
  <Gutter horizontal="24px" bottom="32px">
    <Card name="self-service-no-profile">
      <CardSection divider>
        <EmptyLayout
          graphic={
            <Visible only="largeScreen">
              <NoResults
                width="200px"
                height="200px"
                data-test="no-result-graphic"
              />
            </Visible>
          }
          graphicPosition="left"
        >
          <Gutter bottom="16px" />
          <SmallHeader name="self-service-no-profile-header">
            {ClientEngagementNoMatchMessage.title}
          </SmallHeader>
          <Gutter bottom="16px" />
          <Paragraph name="self-service-no-profile-content">
            {ClientEngagementNoMatchMessage.content}
          </Paragraph>
        </EmptyLayout>
      </CardSection>
    </Card>
  </Gutter>
);
